// deps
import React, { createContext } from "react";

// interfaces
import { DineoutCartAction } from "@checkout-core/reducers/DineoutCartReducer";
import { DineoutCartState } from "@swiggy-private/checkout-types";

export enum DineoutCartType {
    TABLE_RESERVATION_CART,
    BILL_PAYMENT_CART,
    EVENT_BOOKING_CART,
    SCENES_FULL_PAYMENT,
    STEAL_STORE_CART,
}

interface DineoutCartContextType {
    cartType: DineoutCartType | null;
    setCartType: (cartType: DineoutCartType | null) => void;
    cartState: DineoutCartState;
    setCartState: React.Dispatch<DineoutCartAction>;
    uniqueIdForCart: string;
    setUniqueIdForCart: (uniqueIdForCart: string) => void;
}

export const DineoutCartContext = createContext<DineoutCartContextType>({
    cartType: null,
    setCartType: () => void 0,
    cartState: {
        localCart: null,
        reviewedCart: null,
    },
    setCartState: () => void 0,
    uniqueIdForCart: "",
    setUniqueIdForCart: () => void 0,
});
